import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getDefaultRoute } from '../config/navigation';

const NotFound = () => {
  const { t } = useLanguage();
  const defaultRoute = getDefaultRoute();

  return (
    <div className="min-h-[calc(100vh-8rem)] flex items-center justify-center bg-white rounded-lg">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          {t('notFound.title', 'Page Not Found')}
        </h2>
        <p className="text-gray-600 mb-8">
          {t('notFound.message', 'The page you are looking for does not exist or you do not have access to it.')}
        </p>
        <Link
          to={defaultRoute}
          className="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          {t('notFound.goHome', 'Go to Home')}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;

